import { Organisation } from "@inrange/building-manager-api-client/models-organisation";
import {
  Site,
  SiteCalculations,
} from "@inrange/building-manager-api-client/models-site";
import formatPercentage from "../../../theme-components/src/formatting/formatPercentage";

export const getSiteOwnership = (site: Site, organisation: Organisation) => {
  return site.siteOwnerships.find(
    (siteOwnership) => siteOwnership.orgID === organisation.id
  );
};

export const getOrgSpv = (organisation: Organisation, spvId: string) => {
  return organisation.spvs?.find((spv) => spv.uuid === spvId);
};

export const getOwnership = (site: Site, organisation: Organisation) => {
  return getSiteOwnership(site, organisation)?.ownership;
};

const hasOwnerOccupier = (site: Site) => {
  return site.siteOwnerships.some(
    (siteOwnership) => siteOwnership.ownership === "ownerOccupier"
  );
};

export const siteIRR = (
  site: Site,
  siteCalculations?: SiteCalculations,
  organisation?: Organisation
) => {
  const showCustomerIrr =
    site.activeInvestmentModel === "license" && site.totalInstalledCapacity > 0;
  const showInrangeIrr =
    site.activeInvestmentModel === "lease" && site.totalInstalledCapacity > 0;

  if (!showCustomerIrr && !showInrangeIrr) {
    return "N/A";
  }

  if (showCustomerIrr) {
    let ownership = organisation
      ? getOwnership(site, organisation)
      : hasOwnerOccupier(site)
        ? "ownerOccupier"
        : "landlord";
    if (ownership === "tenant") {
      ownership = "landlord";
    }
    const financialModels = (siteCalculations ?? site).financialModels!;
    if (!ownership || !financialModels[ownership]) {
      return "N/A";
    }
    const irr = financialModels[ownership!]["license"].irr;
    return irr ? formatPercentage(irr, 2) : "N/A";
  }

  const financialModelsInrange = (siteCalculations ?? site)
    .financialModelsInrange!;
  return financialModelsInrange?.lease?.irr
    ? formatPercentage(financialModelsInrange?.lease?.irr, 2)
    : "N/A";
};
